<template>
  <div id="app">
    <router-view />
  </div>
</template> 

<script>
export default {
  name: 'App',
  data () {
    return {
      excludedRoutes: [
        'report',
        'UrlScheme',
        'activity',
        'invite',
        'privacy',
        'xmprivacy',
        'hmprivacy',
        'recycle'
      ],
      shareRoutes: {
        mobile: '/share',
        pc: '/sharePc'
      }
    }
  },
  mounted () {
    let resizeTimeout
    window.onresize = () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        this.rem()
      }, 200) // 200 毫秒防抖
    }

      console.log(this.$route);
      const cleanPath = window.location.hash.match(/^#\/[^&?]+/)[0].replace("#", "");
      console.log('cleanPath',cleanPath);
    if (!this.excludedRoutes.includes(this.$route.name)) { 
      const targetPath = this._isMobile() ? this.shareRoutes.mobile : this.shareRoutes.pc
      this.$router.push({
        path: targetPath,
        query: {
          id: this.$route.query.id,
          skuId: this.$route.query.skuId
        }
      })
    }
  },
  methods: {
     isDouyinWebView() {
  return /Douyin/i.test(navigator.userAgent);
},
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    rem () {
      const docEl = document.documentElement
      window.rem = docEl.getBoundingClientRect().width / 24
      console.log(rem)
      docEl.style.fontSize = window.rem + 'px'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

a {
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
}

#app {
  background: #fcfafa;
  min-height: 100vh;
  overflow: auto;
}

input {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue